export default __webpack_public_path__ + "static/media/trash.259059c2.svg";